import { VIDEO_TILE_WIDTH } from '@/components/VideoTile';
import { AvatarTile } from '@/pages/avatar';
import { SectionTitle } from '@/pages/home/components/Common';
import { Presenter } from '@d-id/types';
import styled from '@emotion/styled';

const GridContainer = styled.div`
    display: grid;
`;

const LibraryContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const AvatarsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${VIDEO_TILE_WIDTH}px, 1fr));
    grid-row: 1; /* Ensure each row takes up equal height */
    grid-gap: 24px;
`;

interface Props {
    avatars?: Presenter[];
}

export const DefaultLibrary = ({ avatars = [] }: Props) => {
    if (!avatars.length) {
        return null;
    }

    return (
        <LibraryContainer data-testid="avatar-library-container">
            <SectionTitle>D-ID Avatars</SectionTitle>
            <GridContainer>
                <AvatarsContainer data-testid="avatar-library-container">
                    {avatars.map(a => (
                        <AvatarTile key={a.id} avatar={a} isAiGenerated={!!a.is_aiGenerated} />
                    ))}
                </AvatarsContainer>
            </GridContainer>
        </LibraryContainer>
    );
};
